export enum BookingStatus {
  Pending = 0,
  Confirmed = 1,
  Cancelled = 2,
  Declined = 3,
}

export interface DeclineBookingRequest {
  applyToSeries: boolean;
}

export interface ApproveBookingRequest {}

export enum BookingScope {
  Personal = 0,
  School = 1,
  Classroom = 2,
}

export enum BookingMeetingProvider {
  Manual = "manual",
  GoogleMeet = "google-meet",
  MicrosoftTeams = "microsoft-teams",
  Zoom = "zoom",
}

export enum BookingRecurrenceFrequency {
  Weekly = 1,
  Monthly = 2,
  Yearly = 3,
}

export interface BookingDto {
  id: string;
  title: string;
  description?: string | null;
  isRecurring?: boolean;
  recurrenceFrequencyId?: number | null;
  recurrenceUntilUtc?: string | null;
  recurrenceSeriesId?: string | null;
  startUtc: string;
  endUtc: string;
  timezone?: string | null;
  ownerUserId: string;
  createdByUserId?: string;
  participantUserIds: string[];
  approvedParticipantUserIds?: string[];
  declinedParticipantUserIds?: string[];
  statusId: number;
  scopeId: number;
  classroomId?: string | null;
  classroomTitle?: string | null;
  requiresCredit?: boolean;
  creditAmount?: number;
  creditDebitStatusId?: number;
  creditDebitedAtUtc?: string | null;
  hasInsufficientCreditWarning?: boolean;
  insufficientCreditParticipantUserIds?: string[];
  meetingProvider?: string | null;
  meetingCode?: string | null;
  meetingJoinUrl?: string | null;
  meetingHostUrl?: string | null;
  meetingSource?: string | null;
  createdAtUtc?: string;
  updatedAtUtc?: string;
}

export interface BookingSearchRequest {
  fromUtc: string;
  toUtc: string;
  scopeId?: BookingScope;
  participantUserId?: string;
  ownerUserId?: string;
  statusId?: BookingStatus;
}

export interface BookingSearchResponse {
  items: BookingDto[];
}

export interface UpsertBookingRequest {
  title: string;
  description?: string;
  isRecurring?: boolean;
  recurrenceFrequencyId?: number;
  recurrenceUntilUtc?: string;
  startUtc: string;
  endUtc: string;
  timezone?: string;
  scopeId?: BookingScope;
  classroomId?: string;
  classroomTitle?: string;
  meetingProvider?: string;
  meetingCode?: string;
  meetingJoinUrl?: string;
  meetingHostUrl?: string;
  meetingSource?: string;
  participantUserIds: string[];
  gRecaptchaToken?: string;
}

export interface ClassroomParticipantDto {
  userId: string;
  name: string;
  email?: string | null;
}

export interface BookingParticipantsRequest {
  participantUserIds: string[];
}

export interface BookingErrorResponse {
  code: string;
  message: string;
  details?: Record<string, unknown>;
}
